import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getWarehouse = createAsyncThunk('warehouse/getWarehouse',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        page, size, order, query, needToOrder, needPartsToOrder, isOverstock, brands
      } = getState().warehouseFilter;
      const { data } = await authGet('/co/warehouse',
        {
          params: {
            size,
            page,
            ...(order && { order }),
            ...(query && { query }),
            ...(needToOrder && { needToOrder }),
            ...(needPartsToOrder && { needPartsToOrder }),
            ...(isOverstock && { isOverstock }),
            ...(brands?.length && { brands }),
          }
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getWarehouse;
